<template>
    <v-row align="center" class="ml-0" justify="center">
        <v-col cols="12" xs="12" sm="8" md="6" lg="4" xl="4">
            <v-card class="pa-3">
                <v-card-title>
                    <p class="display-1 text--primary">Đăng Nhập</p>
                </v-card-title>
                <v-card-text>
                    <v-form @keyup.native.enter="login">
                        <v-text-field
                                label="Tên đăng nhập"
                                id="username"
                                name="username"
                                prepend-icon="person"
                                type="text"
                                v-model="username"
                                :error-messages="usernameErrors"
                                required
                                outlined
                                @input="$v.username.$touch()"
                                @blur="$v.username.$touch()"
                        ></v-text-field>
                        <v-text-field
                                id="password"
                                label="Mật khẩu"
                                name="password"
                                type="password"
                                prepend-icon="lock"
                                v-model="password"
                                :error-messages="passwordErrors"
                                required
                                outlined
                                @input="$v.password.$touch()"
                                @blur="$v.password.$touch()"
                        ></v-text-field>
                        <p class="text-center">
                            <router-link to="/password/email" class="">Bạn quên mật khẩu?</router-link>
                        </p>
                    </v-form>
                    <v-card-actions class="px-8 align-center">
                    <v-btn
                            xs12
                            color="primary"
                            block
                            height="60"
                            rounded
                            class="white--text font-weight-bold cols-12"
                            @click="login"
                    >Đăng Nhập
                    </v-btn>
                </v-card-actions>
                </v-card-text>

                <p class="text-center mt-4">
                    Chưa có tài khoản?
                    <router-link to="/register">Đăng Ký</router-link>
                </p>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
    import { required } from "vuelidate/lib/validators";
    // import {CONFIG_PAGE} from "../store/actions.type";
    export default {
        data() {
            return {
                username: "",
                password: "",
                has_error: false,
                currentUser: null
            };
        },
        computed: {
          usernameErrors() {
            const errors = [];
            if (!this.$v.username.$dirty) return errors;
            !this.$v.username.required &&
            errors.push("Vui lòng nhập tên đăng nhập.");
            return errors;
          },
          passwordErrors() {
            const errors = [];
            if (!this.$v.password.$dirty) return errors;
            !this.$v.password.required &&
            errors.push("Vui lòng nhập mật khẩu.");
            return errors;
          }
        },
        validations: {
            username: {
                required
            },
            password: {
                required
            }
        },
        methods: {
            async login() {
                this.$v.$touch();
                if (this.$v.$invalid === false) {
                    let username = this.username;
                    let password = this.password;
                    try {
                        this.$store.dispatch("auth_login", {
                            username,
                            password
                        }).then((res) => {
                            localStorage.setItem('showPopupUpdate', 0);
                            localStorage.setItem('showPopupTimelineNotice', 0);

                            /*
                            show popup last timeline notice when customer not read (after login)
                            notice.created_at:    18:00:00 (notice.id= 118)
                            
                            login:                  18:00:02 
                                                    -> laravel: 
                                                    users.last_notice_id: null/116
                                                    check if users.last_notice_id !== notice.id
                                                    update users.last_notice_id = 118
                                                    update users.show_notice_popup = 1
                                                    -> vue: update showPopupTimelineNotice: 0->1 (show popup)
                                                    
                            login:                  18:00:03 -> not show
                                                    check if users.last_notice_id === notice.id
                                                    update users.last_notice_id: 118
                                                    update users.show_notice_popup = 0
                                                    
                            login:                  18:00:03 -> not show
                                                    check if users.last_notice_id === notice.id
                                                    update users.last_notice_id: 118
                                                    update users.show_notice_popup = 0
                                                    
                            notice.created_at:      18:10:11 (notice.id= 119)
                            notice.created_at:      18:19:30 (notice.id= 120)
                            
                            login:                  18:22:02 
                                                    -> laravel: 
                                                    users.last_notice_id: 118
                                                    check if users.last_notice_id !== notice.id
                                                    update users.last_notice_id = 120
                                                    update users.show_notice_popup = 1
                                                    -> vue: update showPopupTimelineNotice: 0->1 (show popup)
                                                    
                            login:                  18:00:03 -> not show
                                                    check if users.last_notice_id === notice.id
                                                    update users.last_notice_id: 120
                                                    update users.show_notice_popup = 0
                                                    
                                                    time + space + money 
                                                    
                            */
                            
                            if (res.data.data.user.show_notice_popup === 1) {
                                localStorage.setItem('showPopupTimelineNotice', 1);
                            }

                            if (res.data.data.user.customer.mobile === null
                            || res.data.data.user.customer.mobile === '') {
                                localStorage.setItem('showPopupUpdate', 1);
                            }
                            this.$router.push({ name: "home" });
                        });
                    } catch (error) {
                        console.log(error);
                    }
                }
            },
            callSetLangActions (event) {
                this.$i18n.locale = event.target.getAttribute('value');
            },
            // getAppName() {
            //     this.$store.dispatch(CONFIG_PAGE).then(data => {
            //         let appName = data.filter(o => o.key == 'key_cp_app_name');
            //         if (appName[0]['value'] != undefined && appName[0]['status']) {
            //             this.appName = appName[0]['value'];
            //             localStorage.setItem('appName', this.appName)
            //         }
            //     })
            // },
        },

        created() {
            // this.getAppName();
        },
        mounted() {
            window.$("#username").focus();
        }
    };

</script>
